/* eslint-disable simple-import-sort/imports -- ORDER IS LOAD-BEARING HERE.
   `viewAsStorage` swaps a viewing tab onto its own storage, and the Redux store
   reads the cart out of storage while its own module is loading — which happens
   the moment `./App` is imported. Sorted alphabetically, the swap lands after
   App and comes too late to do anything. Leave these two first. */
import "./polyfills";
import "./viewAsStorage";

import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

import { applyDemoBanners } from "@utils/demoBanners";
import { ScrollToTop } from "@utils/ScrollToTop";
import { redeemViewCode } from "@utils/viewAs";

import App from "./App";

import "./index.css";
import "./i18n";

// Before the first render: the banners read their flags once, on mount.
applyDemoBanners();

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  rootElement.innerHTML = "";
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const mount = () =>
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </HelmetProvider>,
  );

/**
 * A support view arrives as `?view=<code>` and is redeemed BEFORE the app
 * mounts. The layout asks who the visitor is on its first render, so exchanging
 * afterwards would fire that question as a guest and then contradict it. The
 * code is stripped from the address on the way through, so it is never in the
 * URL bar, a bookmark or the back button — and it is single-use besides.
 */
const viewCode = new URLSearchParams(window.location.search).get("view");
if (viewCode) {
  const url = new URL(window.location.href);
  url.searchParams.delete("view");
  window.history.replaceState({}, "", url.toString());
  redeemViewCode(viewCode).finally(mount);
} else {
  mount();
}
